import { Checkbox, DialogContentText, FormControlLabel, Stack } from "@mui/material";
import React, { Dispatch } from "react";

import { DisqualifyingReason } from "../../../../../Models/DisqualifyingReason";
import { BaseDispositionConfirmationForm, IBaseDispositionConfirmationFormProps } from "./ConfirmationForm";

export const classNames = {
  nonCandidacyOverrideToggle: "dispositionModalCandidacyOverrideToggle"
};

export interface INotReachedConfirmationFormProps extends IBaseDispositionConfirmationFormProps {
  /** The reasons why the current session's guest is disqualified from receiving services. */
  disqualificationReasons: DisqualifyingReason[];
  /** A flag that overrides the normal behaviors of non-candidacy status. */
  isNonCandidacyOverridden: boolean;
  /** Updates the state of the non-candidacy override flag. */
  setIsNonCandidacyOverridden: Dispatch<boolean>;
}

/** An extension of the confirmation form to be used when the disposition type is 'Medical Escalation'. */
export const NotReachedConfirmationForm: React.FC<INotReachedConfirmationFormProps> = ({
  disqualificationReasons,
  isNonCandidacyOverridden,
  setIsNonCandidacyOverridden,
  ...rest
}) => {
  return (
    <BaseDispositionConfirmationForm {...rest}>
      {Boolean(disqualificationReasons.length) && (
        <Stack spacing={2}>
          <DialogContentText>
            {`This guest has been flagged as a non-candidate for the following reasons: ${disqualificationReasons.reduce(
              (str, { name }) => (str ? `${str}, ${name}` : name),
              ""
            )}`}
          </DialogContentText>
          <FormControlLabel
            className={classNames.nonCandidacyOverrideToggle}
            control={<Checkbox checked={isNonCandidacyOverridden} />}
            label="Remove All Non-Can Flags"
            labelPlacement="end"
            onChange={() => setIsNonCandidacyOverridden(!isNonCandidacyOverridden)}
          />
        </Stack>
      )}
    </BaseDispositionConfirmationForm>
  );
};

export default NotReachedConfirmationForm;
